const UpgradePrompt = ({ feature, requiredPlan, setActiveTab }) => (
  <div style={{ padding: '4rem 2rem', textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
    <div style={{ width: '80px', height: '80px', borderRadius: '20px', background: 'linear-gradient(135deg, rgba(255,215,0,0.15), rgba(255,165,0,0.1))', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', fontSize: '2rem' }}>🔒</div>
    <h2 style={{ color: '#e8eaed', margin: '0 0 0.75rem', fontSize: '1.4rem', fontWeight: 700 }}>{feature}</h2>
    <p style={{ color: '#8b8fa3', lineHeight: 1.6, margin: '0 0 1.5rem', fontSize: '0.95rem' }}>
      This feature is available on the <span style={{ color: '#FFD700', fontWeight: 600 }}>{requiredPlan}</span> plan and above. Upgrade to unlock it.
    </p>
    <button onClick={() => setActiveTab('admin')} style={{
      background: 'linear-gradient(135deg, #d4a853, #e8c875)', color: '#080a10', border: 'none',
      padding: '0.8rem 2rem', borderRadius: '12px', fontSize: '0.95rem', fontWeight: 700,
      cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.3s',
    }}>View Plans & Upgrade</button>
  </div>
);

export default UpgradePrompt;
